import Marquee from "react-fast-marquee";

const ITEMS = [
  "Value",
  "Functionality",
  "Sustainability",
  "Exposed Aggregate",
  "Honed Concrete",
  "Liquid Limestone",
];

export const EditorialMarquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="noise-dark overflow-hidden border-y border-lec-darkline bg-lec-ink py-6"
  >
    <div className="relative z-10">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-lec-bone/90 md:text-base">
              {item}
            </span>
            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-lec-green" />
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
